export function dataInRequest(params = {}) {
    return {
        type: '@manutexcluirvazamento/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@manutexcluirvazamento/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@manutexcluirvazamento/FAILED_REQUEST',
    };
}

export function deleteData(id, params) {
    return {
        type: '@manutexcluirvazamento/DELETE_DATA',
        payload: { id, params },
    };
}

export function updateData(data, params) {
    return {
        type: '@manutexcluirvazamento/UPDATE_DATA',
        payload: { data, params },
    };
}
export function cancelarVazamento(data, params) {
    return {
        type: '@manutexcluirvazamento/CANCELAR_VAZAMENTO',
        payload: { data, params },
    };
}

export function storeData(data, params) {
    return {
        type: '@manutexcluirvazamento/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@manutexcluirvazamento/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@manutexcluirvazamento/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@manutexcluirvazamento/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@manutexcluirvazamento/RECORD_FILTERING',
        payload: { params },
    };
}